
import { mapGetters, mapActions } from 'vuex'

const getSinglePages = {
  data: () => ({
    loading: true
  }),
  computed: {
    ...mapGetters('contentful', [
      'singlePage',
      'singlePages'
    ])
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful', [
      'loadSinglePages'
    ]),
    $_getPageSlug (template) {
      if (this.loading) return undefined
      const page = this.singlePages.find(singlePage => template === singlePage.fields.template)
      if (page === undefined) return undefined
      return page.fields.slug
    },
    async loadData () {
      this.loading = true
      try {
        await Promise.all([this.loadSinglePages()])
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    }
  }
}

export default getSinglePages
